import classNames from "classnames"
import PropTypes from "prop-types"
import React, { useId } from "react"

import Tooltip from "src/components/Tooltip"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const InvoiceBalanceCard = ({
  title,
  info,
  amountInCents,
  detail,
  currency,
  isAlert = false,
}) => {
  const titleId = useId()

  return (
    <div
      role="group"
      aria-labelledby={titleId}
      className="flex flex-1 cursor-default flex-col space-y-1 rounded-lg border border-gray-300 p-4 shadow-base"
    >
      <div className="flex h-6 flex-row items-center space-x-1 text-sm text-gray-900">
        <div id={titleId}>{title}</div>
        <Tooltip text={info} placement="top" variant="dark" tabIndex={0}>
          <i
            role="img"
            aria-label={info}
            className="fa-regular fa-circle-info fa-lg text-gray-600"
          />
        </Tooltip>
      </div>
      <div>
        <div
          className={classNames("text-4xl font-bold leading-snug", {
            "text-red-700": isAlert,
          })}
        >
          {formatCurrencyFromMinorUnits({ amount: amountInCents, currency })}
        </div>
        <div className="text-sm text-gray-600">{detail}</div>
      </div>
    </div>
  )
}

InvoiceBalanceCard.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  amountInCents: PropTypes.number.isRequired,
  detail: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  isAlert: PropTypes.bool,
}

export default InvoiceBalanceCard
